module.exports = __webpack_public_path__ + "img/nossa.bd005dc3.png";